(ns common.archive-modal.view
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            [common.modal.view :refer [defmodal modal-v2]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$]]))

(defmodal archive-modal :confirm-archive
  [{:keys [event type on-confirm]}]
  (uix/use-effect (fn []
                    (rf/dispatch [:confirm-archive/init])
                    (fn []
                      (rf/dispatch [:confirm-archive/destroy])))
                  [])
  ($ modal-v2
     {:title (str "Archive " type "?")
      :footer ($ :<>
                 ($ Button
                    {:onClick #(rf/dispatch [:modal/close])}
                    "Cancel")
                 ($ Button
                    {:variant "contained"
                     :color "error"
                     :onClick (cond
                                event #(rf/dispatch event)
                                on-confirm on-confirm)
                     :type "submit"}
                    "Archive"))}
     ($ Box {:sx #js {:width "400px"}}
        (str "Archiving your " type
             " will result in it being hidden from
              your default view. Confirm if you want to proceed."))))
